module.exports = __webpack_public_path__ + "media/images/file-cross-71bd8566124d234321d28016ae284fe8.svg";